import React, { Component } from 'react';
import { canUseDOM } from 'exenv';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import axios from 'axios';
import uniqBy from 'lodash/uniqBy';
import FCLink from '../fc_link/fc_link';
import { trainParselyProfile } from '../../../client/utils/third_party_trackers/parsely';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';

class PersonalizedRecommendations extends Component {
  constructor() {
    super();
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.state = {
      personalizedRecommendations: []
    };
  }

  componentWillMount() {
    if (canUseDOM) {
      this.fetchRecommendations();
      // track a widget viewed event to better gauge ctr %
      trackGAEvent({
        eventCategory: 'related',
        eventAction: 'viewed',
        eventLabel: 'article-page'
      });
    }
  }

  shouldComponentUpdate() {
    // If we don't do this, this widget will render every time inf scroll happens
    return this.state.personalizedRecommendations.length === 0;
  }

  fetchRecommendations() {
    const uuid = get(window, 'PARSELY.config.uuid');
    const { config, link } = this.props;
    const site = get(config, 'site');

    // https://www.parse.ly/help/api/time/
    // https://trello.com/c/YAM79Xv5/1740-add-a-4th-you-may-also-like-link-video-permalinks
    const pubDateStart = '35w';
    const pubDateEnd = '1m';

    // https://www.parse.ly/help/api/recommendations/#personalized
    Promise.all([
      axios.get('https://fc-api.fastcompany.com/api/v1/jw-playlist/Y4a4AwUd/1'),
      axios.get(
        `https://api.parsely.com/v2/related?apikey=${site}.com&url=${
          link
        }&uuid=${uuid}&pub_date_start=${pubDateStart}&pub_date_end=${
          pubDateEnd
        }`
      )
    ]).then(res => {
      if (res.length) {
        const randomSeed = Math.floor(Math.random() * 9) + 0;
        const videoPlaylistData = get(res, '[0].data.playlist', []);

        // Select a random video from list, and append it to 4th item in result
        const randomVideo = videoPlaylistData[randomSeed];
        const randomVideoNormalized = {
          title: `Video: ${get(randomVideo, 'title')}`,
          section: 'video',
          url: get(randomVideo, 'link')
        };
        const parselyData = get(res, '[1].data.data', []);

        if (parselyData.length) {
          parselyData.splice(3, 0, randomVideoNormalized);
        }

        this.setState({
          personalizedRecommendations: this.sanitizeRecommendations(parselyData)
        });
      }
    });
  }

  sanitizeRecommendations(recommendations) {
    // 1. Remove titles with Fast Company or Fastcodesign
    // 2. Remove any advertorial posts from non-advertorial posts
    // 3. Dedup any title
    const MAX_STORIES = 4;
    const { isAdvertorial } = this.props;
    const sanitizedRecommendations = uniqBy(recommendations, link => {
      const title = get(link, 'title', '');
      return title.toLowerCase();
    }).filter(link => {
      if (isAdvertorial) {
        return (
          link.title !== 'Fast Company' &&
          link.title !== 'Fastcodesign' &&
          !link.url.includes('stage') &&
          !link.url.includes('.local')
        );
      }

      return (
        link.title !== 'Fast Company' &&
        link.title !== 'Fastcodesign' &&
        link.section !== 'advertorial' &&
        !link.url.includes('stage') &&
        !link.url.includes('local')
      );
    });

    if (sanitizedRecommendations.length > MAX_STORIES) {
      return sanitizedRecommendations.slice(0, MAX_STORIES);
    }

    return sanitizedRecommendations;
  }

  render() {
    const { personalizedRecommendations } = this.state;

    const { config } = this.props;

    if (!personalizedRecommendations.length) {
      return '';
    }

    return (
      <section className="post-personalized-recommendations">
        <h3 className="post-personalized-recommendations__header">
          You Might Also Like:
        </h3>
        <ul className="post-personalized-recommendations__list">
          {this.sanitizeRecommendations(personalizedRecommendations).map(
            (link, index) => (
              <li
                className="post-personalized-recommendations__item"
                key={index}
                onClick={() => {
                  let position = index;
                  position += 1;
                  trackGAEvent({
                    eventCategory: 'related',
                    eventAction: 'clicked',
                    eventLabel: `algorithm=parsely,location=article-bottom,position=${
                      position
                    }`
                  });
                  trainParselyProfile(link.url);
                }}
              >
                <FCLink config={config} title={link.title} to={link.url}>
                  {link.title}
                </FCLink>
              </li>
            )
          )}
        </ul>
      </section>
    );
  }
}

PersonalizedRecommendations.propTypes = {
  config: PropTypes.shape({}).isRequired,
  link: PropTypes.string.isRequired,
  isAdvertorial: PropTypes.bool.isRequired
};

export default PersonalizedRecommendations;



// WEBPACK FOOTER //
// ./src/views/components/personalized_recommendations/personalized_recommendations.js